export const MARK_REACHABLE_ENTITIES = 'entities/MARK_REACHABLE_ENTITIES' as const;

export const TRAVERSE_STATE_KEYS = [
    'betslip',
    'match',
    'matchList',
    'favorite',
    'stream',
    'banners',
] as const;

export type TraverseStateKeys = typeof TRAVERSE_STATE_KEYS[number];
